/* eslint-disable */

export default {
	common: {
		'1': 'January',
		'2': 'February',
		'3': 'March',
		'4': 'April',
		'5': 'May',
		'6': 'June',
		'7': 'July',
		'8': 'August',
		'9': 'September',
		'10': 'October',
		'11': 'November',
		'12': 'December',
		adults: 'Adults',
		children: 'Children',
		bookNow: 'BOOK NOW',
		prev: 'Prev',
		backToHome: 'Back To Home',
		next: 'Next',
		detail: 'Detail',
		selectDate: 'Select Date',
		selectHotel: 'Select Hotel',
		onlineTravelFair: '線上旅展',
		bookNowBtn: 'BOOK NOW',
	},
	pageTitle: {
		brandName: 'Just Sleep',
		main: 'Brand',
		news: 'Promotions',
		privacy: 'Privacy and Cookies Policy',
		accommodation: 'Rooms',
		facility: 'Amenities',
		restaurant: 'Dinings & Meetings',
		location: 'Directions',
		activity: 'Activities',
	},
	header: {
		main: 'BRAND',
		news: 'PROMOTIONS',
		index: 'HOME',
		accommodation: 'ROOMS',
		facility: 'AMENITIES',
		restaurant: 'DININGS & MEETINGS',
		location: 'DIRECTIONS',
		activity: 'ACTIVITIES',
		bookNow: 'BOOK NOW',
		taiwan: 'TAIWAN',
		japan: 'JAPAN',
		onlineTravelFair: '線上旅展',
		bookNowBtn: 'BOOK NOW',
	},
	footer: {
		registrationNumber: 'Hotel Registration Number',
		privacy: 'Privacy and Cookies Policy',
	},
	cookieBar: {
		attention: '<p>We value and respect your privacy.</p>\n<p>The Silks Hotel Group uses its own and selected third-party cookies on this site to improve performance, for analytics and for advertising. By browsing this site, you are agreeing to this. We encourage you to review our full {{privacyLink}} for more information.</p>',
		privacy: 'Privacy and Cookies Policy',
		accept: 'CONTINUE TO SITE',
	},
	homePage: {
		title: 'Comprehensive Luxury for Smart Travelers',
		about: 'About',
		aboutJustsleep: 'About Just Sleep',
		toHotelSite: 'Discover',
		more: 'Read More',
		justNews: 'Just News',
		justComfortTitle: 'Just Sleep',
		justComfortBackTitle: 'Just Sleep',
		justComfortContent: 'The hotel offers you the different choice of the pillows. It makes every tourists live in Just Sleep can get the comfortable sleep quality.',
		justGoTitle: 'Just Play',
		justGoBackTitle: 'Just Play',
		justGoContent: 'We offer the tourism information service according to every tourist’s requirement to recommend the spot, shopping stores and traffic information in hotel.',
		justEquipTitle: 'Just Spares',
		justEquipBackTitle: 'Just Spares',
		justEquipContent: 'We offer the special spares such as selfie stick, mobile phone charger, mobile power pack, lamp and so on(only for Ximen and NTU hotel).',
		justBuyTitle: 'Just Buy',
		justBuyBackTitle: 'Just Buy',
		justBuyContent: 'We offer the service about purchasing special souvenir in Taiwan to save tourists time and travel easily.',
		justPackTitle: 'Just Pack',
		justPackBackTitle: 'Just Pack',
		justPackContent: 'We offer the service about weighting your baggage and choosing the box for each size. The bearer will help you pack for free to make you return easily.',
		justRelax: 'Just Convenience',
		justSight: 'Just Sight',
		justGo: 'Just Go',
		justExplore: 'Just Explore',
		justService: 'Just Service',
	},
	accommodationPage: {
		rooms: 'ROOMS',
		roomFacilityTitle: 'In-room Amenities',
		lookupRoomType: 'Check Room Type',
		have: '',
		roomType: 'Room Type',
		am: 'AM',
		pm: 'PM',
		checkInTime: 'Check-in',
		checkOutTime: 'Check-out',
		detail: 'Detail',
		bookNow: 'BOOK NOW',
	},
	locationPage: {
		location: 'DIRECTIONS',
		trainInfo: 'By Train / High Speed Rail',
		busInfo: 'By Bus',
		driveInfo: 'By Driving',
		parkInfo: 'Parking',
		hotelInfo: 'Transport Service',
		airplaneInfo: 'From Airport',
	},
	newsHomePage: {
		all: 'All',
		news: 'PROMOTIONS',
		selectType: 'Select Type',
		more: 'Read More',
	},
	newsPage: {
		projectTime: 'Project Time',
		projectDetail: 'Project Detail',
		note: 'Remark',
	},
	restaurantPage: {
		restaurantsAndMeetings: 'DININGS & MEETINGS',
		restaurant: 'Dinings',
		meeting: 'Meetings',
	},
	activityPage: {
		activity: 'ACTIVITIES',
		attractionsNearby: 'Attractions',
		more: 'Read More',
		lookupSchedule: 'Read More',
		join: 'Read More',
	},
	facilityPage: {
		facility: 'AMENITIES',
		lookup: 'Read More',
	},
	justFunSection: {
		justFunTitle: 'Just Fun',
		justFun: 'Ten Features',
	},
	hotelMain: {
		name: 'Brand',
		longName: 'Brand',
		title: '',
		bannerText: 'Just Sleep',
		contactUs: 'Customer Service',
		address: 'No. 83, Section 4, Roosevelt Rd, Da’an District, Taipei City, 106',
		intro: '"Just Sleep" is a boutique design hotel brand under Silks Hotel Group. Upholding the brand spirit of "style, comfort, and attention to detail," Just Sleep provides travelers with high-quality services comparable to five-star hotels at affordable prices.\n',
	},
	hotelXimen: {
		name: 'Taipei Ximending',
		title: 'Hotel Near MRT Ximen Station',
		contactUs: 'Customer Service',
		address: '5F, No. 41, Sec. 1, Zhonghua Rd., Taipei 10042, Taiwan (Please enter from No.144, Sec. 1, Hankou St entrance.)',
		intro: 'Just Sleep Taipei Ximending is close to the bustling and lively Ximen shopping district. The tourists can travel to the historic spot in Taipei and experience not only the new culture, but also the local food.',
	},
	hotelNTU: {
		name: 'Taipei NTU',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 83, Sec. 4, Roosevelt Rd., Taipei 10673, Taiwan',
		intro: 'Just Sleep Taipei NTU is located beside the National Taiwan University. It offers a comfortable accommodation choice for those people who go teaching, interning, researching, academic communication, meeting and touring. The hotel mixes the design of free college style to create an atmosphere of mutual prosperity with the campus.',
	},
	hotelZhongshan: {
		name: 'Taipei Zhongshan',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 39, Ln. 135, Sec. 1, Zhongshan N. Rd., Zhongshan Dist., Taipei 10441, Taiwan',
		intro: 'Located in the vibrant Zhongshan District—where rich history meets modern energy—Just Sleep Taipei Zhongshan offers unparalleled convenience just steps from MRT Zhongshan Station. Guests can easily explore the bustling Tiaotong and Zhongshan shopping districts, experiencing a perfect blend of old-town charm and contemporary Taipei.',
	},
	hotelKaohsiung: {
		name: 'Kaohsiung Zhongzheng',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 134, Zhongzheng 1st Rd., Kaohsiung 80284, Taiwan',
		intro: '\"Just Sleep Kaohsiung Zhongzheng\" is designed with a music theme and offers both trendy style and practical functionality. It\'s close to Kaohsiung MRT Lingya Sports Park Station, Weiwuying National Kaohsiung Center for the Arts, and Wumiao Night Market, providing travelers with a unique stay experience.\n',
	},
	hotelKaohsiungStation: {
		name: 'Kaohsiung Station',
		title: '',
		contactUs: 'Customer Service',
		address: 'No.280, Zhongshan 1st Rd., Xinxing Dist., Kaohsiung City 800, Taiwan ',
		intro: "Just Sleep Kaohsiung Station's unique design includes exquisite original art works and custom-made designer furnishings. It is conveniently close to the Kaohsiung transition , Formosa Boulevard Station and Liuohe Tourist Night Market.",
	},
	hotelHualien: {
		name: 'Hualien Zhongzheng',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 396, Zhongzheng Rd., Hualien 97041, Taiwan',
		intro: 'Just Sleep Hualien Zhongzheng is centrally located in Hualien City, a quiet place amidst the bustling area. Enter the hotel and immediately feel lighthearted and relaxed.',
	},
	hotelJiaoxi: {
		name: 'Yilan Jiaoxi',
		title: 'Yilan hot spring hotel',
		contactUs: 'Customer Service',
		address: 'No. 8, Ln. 24, Deyang Rd., Jiaoxi Township, Yilan, Taiwan',
		intro: 'Just Sleep Yilan Jiaoxi is close to the lively Jiaoxi shopping district. The hotel offers sodium bicarbonate hot spring. The design hotel is a new sign in Jiaoxi district. The tourists can go to the famous sightseeing spot such as Wufongci Designated Scenic Area, Tangwei Brook Park and so on by walking.',
	},
	hotelSanchong: {
		name: 'Taipei Sanchong',
		title: '',
		contactUs: 'Customer Service',
		address: 'No.107-1,Sec.4,Sanhe Rd.,Sanchong Dist.,New Taipei City 24152,Taiwan',
		intro: 'Just Sleep Taipei Sanchong is ideally located in front of MRT Sanhe Junior High School Station and offers convenient traffic connections. It is an excellent choice for both business travelers and tourists. The soft loft industrial design coupled with hand-roasted coffee and Taiwan whole leaf tea ensures maximum comfort and coziness and an experience of warm and genuine hospitality for each traveler.',
	},
	hotelHushan: {
		name: 'Tainan Hushan',
		title: '',
		contactUs: 'Customer Service',
		address: 'No. 300, Sec. 2, Wenhua Rd., Rende Dist., Tainan City 717015 Taiwan',
		intro: 'Just Sleep Tainan Hushan is located right next to Ten-Drum Cultural Village and CHIMEI Museum, so travelers can conveniently enjoy cultural and artistic spots. With excellent access to High-Speed Railway Tainan station, Tainan Airport and Highways, it is a brilliant location for business activities and family trip.',
	},
	hotelOsakaShinsaibashi: {
		name: 'Osaka Shinsaibashi',
		title: '',
		contactUs: 'Customer Service',
		address: '2-chōme-9-15 Minamisemba, Chuo Ward, Osaka, 542-0081',
		intro: "Just Sleep Osaka Shinsaibashi is the first Just Sleep brand hotel in Japan, and the hotel's location is close to the bustling Shinsaibashi shopping district, lined with gourmet shops, and within walking distance to a place where you can experience local fashionable culture and hospitality.\nTransportation is very convenient with easy access to four major subway stations: Shinsaibashi Station, Hommachi Station, Sakaisuji Hommachi Station and Nagahoribashi Station. It is a very convenient hotel for going out, so it will be the best hotel for individul traveler in Osaka.",
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889',
	},
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/resources/en.js